import { InfoIcon } from "../../svg/info-icon";

const TextWithAuthStatus = ({ status }: { status?: string }) => {
  return (
    <div className="text-with-status-container flex items-center gap-2 rounded-md bg-secondaryYellow-11 px-2 py-3">
      <span>
        <InfoIcon height="16" width="16" stroke="#0056d6" strokeWidth="1.4" />
      </span>
      <div className="auth-status-information text-sm font-regular text-primaryGray-1">
        This case will be moved to the&nbsp;
        <strong className="font-bold">&nbsp;{status ?? ""}</strong> queue.
      </div>
    </div>
  );
};

export default TextWithAuthStatus;
